import _ from 'underscore';
import { PromoModalDetails } from 'blocks/Pricing/types';
import { getMyPlanPath } from 'utils/routes';
import { PromoModalDetailsWithTemplate } from './types';

const createDetails = (
  details: PromoModalDetails,
): PromoModalDetailsWithTemplate => ({
  ...details,
  descriptionTemplate: _.template(details.description),
});

export const PRO_TRIAL_DETAILS = createDetails({
  modalTitle: 'Your Free Trial of Pro',
  title: "Congrats, you've gone Pro!",
  description:
    "You've activated your free trial of Headliner Pro, enjoy all of our premium features until your trial ends on <%= expirationDate %>.",
  cta: 'start creating',
});

export const COUPON_DETAILS = createDetails({
  modalTitle: 'Get BOGO Headliner',
  title: "Congrats, you've got BOGO!",
  description:
    "Nice, you've unlocked Buy One, Get One Free. Head to your My Plan page, pick any plan, and enjoy double the time — yep, up to a whole year of Pro on us.",
  cta: 'get bogo headliner',
  redirectTo: getMyPlanPath(),
});
